export { Base } from "./FlightIndexParam/Base";
export type { IBase } from "./FlightIndexParam/Base";
export { OneWay } from "./FlightIndexParam/OneWay";
export type { IOneWay } from "./FlightIndexParam/OneWay";
export { MultiCity } from "./FlightIndexParam/MultiCity";
export type { IMultiCity } from "./FlightIndexParam/MultiCity";
export { RoundTrip } from "./FlightIndexParam/RoundTrip";
export type { IRoundTrip } from "./FlightIndexParam/RoundTrip";
